module.exports = __webpack_public_path__ + "static/media/background05.ff3d8b78.jpg";